import { Box, Row, Text } from '~/commonComponents';
import ConfirmPopup from '~/components/shared/ConfirmPopup';
import HeartIcon from '~/images/icons/Heart';
import { CheckIcon } from '~/images/icons/CheckIcon';
import { Colors } from '~/themes/colors';

interface IFavoriteAddedPopupProps {
  professionalName: string;
  onClose: () => void;
}

export const FavoriteAddedPopup = ({ professionalName, onClose }: IFavoriteAddedPopupProps) => (
  // @ts-expect-error - missing type
  <ConfirmPopup
    dataCy="favorite-added-popup"
    title="Congrats!"
    description={`${professionalName} has been added to your Favorites.`}
    descriptionStyle={{ marginBottom: 16 }}
    rightButtonText="Close"
    rightButtonAction={onClose}
    rightButtonDataCy="favorite-added-close-button"
    closePopup={onClose}
  >
    <Row alignItems="center" gap={8} marginBottom={16}>
      <HeartIcon color={Colors.favorites_400} width={20} height={20} outline={false} />
      <Text bold fontSize={18} color={Colors.favorites_400}>
        Added to Favorites
      </Text>
      <CheckIcon color={Colors.favorites_400} size={20} />
    </Row>

    <Box
      style={{
        border: `1.5px solid ${Colors.favorites_400}`,
        backgroundColor: '#F9F5FD',
        borderRadius: 8,
        boxSizing: 'border-box' as const,
      }}
      width="90%"
      padding={16}
      marginBottom={24}
    >
      <Text fontSize={16} color={Colors.neutral_500} textAlign="center" lineHeight="1.4">
        This professional is now a Favorite! To speed up coverage when posting shifts, turn on
        Auto-Confirm for Favorites to reconnect with confidence.
      </Text>
    </Box>
  </ConfirmPopup>
);
